import url from "../../config/url";

async function getStatusPeriods({ idPlanta, column, fechaInicio, fechaFin }) {
  try {
    const response = await fetch(`${url}electric/status_periods`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": process.env.REACT_APP_API_KEY
      },
      body: JSON.stringify({
        idPlanta,
        column,
        fechaInicio,
        fechaFin
      })
    });

    if (!response.ok) {
      throw new Error("Failed to fetch status periods");
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error("Error fetching status periods:", error);
    throw error;
  }
}

export { getStatusPeriods };
